(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("LearningItemEditOnlineLessonModalCtrl", ["$scope", "notify", "$window", "learningItemOnlineLessonResource", "learningItemOnlineLesson", learningItemEditOnlineLessonModalCtrl]);
    function learningItemEditOnlineLessonModalCtrl($scope, notify, $window, learningItemOnlineLessonResource, learningItemOnlineLesson) {
        var vm = this;
        vm.learningItemOnlineLesson = learningItemOnlineLesson;
        vm.showErrors = false;
        vm.updateLearningItemOnlineLesson = function (isValid) {
            if (isValid) {
                learningItemOnlineLessonResource.update({ id: vm.learningItemOnlineLesson.id }, vm.learningItemOnlineLesson, function (result) {
                    vm.learningItemOnlineLesson = result;
                    notify({ messageTemplate: "<span translate='learningItem.updatedSuccessMessage'></span>", classes: "alert-success" });
                    $scope.$close(result);
                }, function () {
                    notify({ messageTemplate: "<span translate='common.genericError'></span>", classes: "alert-danger" });
                });
            }
            else {
                vm.showErrors = true;
            }
        };
    }
})();
